import React, { Fragment } from "react";
import { cls } from "@wss/cls";
import { Specification } from "./ProductDetailPageResult";
interface SpecificationTableProps {
  specifications: Specification[];
  name: string;
  itemNumber: string;
  showInSidebar: boolean;
  unitOfMeasure?: string;
  unitsPerPackaging?: number;
  weightInPounds: number;
}
const commonTableClasses = "py-2 border-gray-200 border-t-0 border-b border-solid text-sm leading-4 px-4";
const dtClasses = `${commonTableClasses} border-r-0 border-l bg-gray-50 font-semibold`;
const ddClasses = `${commonTableClasses} border-r border-l-0 bg-white`;
const SpecificationTable = ({
  specifications,
  name,
  itemNumber,
  unitOfMeasure,
  unitsPerPackaging,
  showInSidebar,
  weightInPounds
}: SpecificationTableProps) => {
  const roundedShippingWeight = () => {
    if (weightInPounds < 0.005) {
      return 0.01;
    }
    return Math.round((weightInPounds + Number.EPSILON) * 100) / 100;
  };
  return <div className={showInSidebar ? "box sidebar-spectable" : "feature"} data-sentry-component="SpecificationTable" data-sentry-source-file="SpecificationTable.tsx">
      <div id="specifications-group" data-testid="specifications-group" className="border-y-0 table-stylized table-bordered table-striped" style={{
      scrollMarginTop: "113px"
    }}>
        <div className="toolbar">
          <p className="specs-text m-0 font-bold text-base bg-white py-2 px-4 border-solid border border-gray-200 rounded-t">{`${name} Specs`}</p>
        </div>
        <dl id="tbSpecSheetRows" data-component="SpecSheet" className="my-0 grid grid-cols-2">
          <Fragment key="quantity">
            <dt className={dtClasses} data-item-number={itemNumber}>
              Quantity
            </dt>
            <dd className={ddClasses} data-item-number={itemNumber}>
              {unitsPerPackaging && unitOfMeasure ? `${unitsPerPackaging.toLocaleString("en-us")}/${unitOfMeasure}` : "1/Each"}
            </dd>
          </Fragment>

          {weightInPounds > 0 && <Fragment key="weight">
              <dt className={dtClasses} data-item-number={itemNumber}>
                Shipping Weight
              </dt>
              <dd className={ddClasses} data-item-number={itemNumber}>
                {weightInPounds > 0 ? roundedShippingWeight() : "-"} lb.
              </dd>
            </Fragment>}

          {specifications?.map((specification, index) => <Fragment key={specification.classification}>
              <dt className={cls(dtClasses, index === specifications.length - 1 ? "rounded-bl border-solid border-zinc-300" : "rounded-none")} data-item-number={itemNumber}>
                {specification.classification}
              </dt>
              <dd className={cls(ddClasses, index === specifications.length - 1 ? "rounded-br border-solid border-zinc-300" : "rounded-none")} data-item-number={itemNumber}>
                {specification.types.map((type, index) => <Fragment key={`${type.name}${type.value}`}>
                    {type.value}
                    {index < specification.types.length - 1 && <span className="block leading-3">&nbsp;</span>}
                  </Fragment>)}
              </dd>
            </Fragment>)}
        </dl>
      </div>
    </div>;
};
export default SpecificationTable;